// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// SignupReferralSource — source: shared/config/signup_referral_source.config.json

export const SIGNUP_REFERRAL_SOURCE_VALUES = ["search_engine", "ai_assistant", "social_media", "word_of_mouth", "existing_user", "event_conference", "press_article", "other"] as const;
export type SignupReferralSource = (typeof SIGNUP_REFERRAL_SOURCE_VALUES)[number];

